import { render, staticRenderFns } from "./auditMail.vue?vue&type=template&id=42f4f998&scoped=true&"
import script from "./auditMail.vue?vue&type=script&lang=js&"
export * from "./auditMail.vue?vue&type=script&lang=js&"
import style0 from "./auditMail.vue?vue&type=style&index=0&id=42f4f998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4f998",
  null
  
)

export default component.exports